var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"ui dropdown",class:{ fluid: _vm.fluid, search: _vm.search },attrs:{"id":_vm._uid,"multiple":_vm.multiple}},[(!_vm.addSelectValue)?_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.selectLabel))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }